// Login.jsx
import React, { useEffect } from "react";
import { Container, Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/Auth/LoginForm";
import useAuth from "../hooks/useAuth";

function Login() {
	const { user } = useAuth();
	const navigate = useNavigate();

	// Redirect to dashboard if already logged in
	useEffect(() => {
		if (user) {
			navigate("/");
		}
	}, [user, navigate]);

	return (
		<Box
			sx={{
				height: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				bgcolor: "#f8f9fa",
			}}
		>
			<Container maxWidth="sm">
				<Paper
					sx={{
						p: 4,
						borderRadius: 2,
						boxShadow: 3,
					}}
				>
					<Box sx={{ textAlign: "center", mb: 4 }}>
						<Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
							Discord Bot Platform
						</Typography>
						<Typography variant="body1" color="text.secondary">
							Sign in to your account
						</Typography>
					</Box>
					<LoginForm />
				</Paper>
			</Container>
		</Box>
	);
}

export default Login;
